module.exports = __webpack_public_path__ + "static/media/no-organisation.92299984.svg";